<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Neuen Lagerort hinzufügen</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button" matTooltip="Schließen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-description">Geben Sie einen Namen für den neuen Lagerort ein.</p>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Lagerort</mat-label>
      <input matInput [(ngModel)]="lagerortName" placeholder="Lagerortname eingeben" autofocus>
      <mat-icon matSuffix>place</mat-icon>
      <mat-hint>Z.B. Regal, Fach oder spezifischer Standort</mat-hint>
    </mat-form-field>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="cancel-button">
      <mat-icon>cancel</mat-icon> Abbrechen
    </button>
    <button mat-raised-button color="primary" (click)="onAdd()" [disabled]="!lagerortName">
      <mat-icon>add</mat-icon> Hinzufügen
    </button>
  </mat-dialog-actions>
</div>
